import Head from 'next/head';
import React, { FunctionComponent } from 'react';

import { LOCALES, PRODUCTION_DOMAIN, SEO } from '../../../constants';
import { BasicSeoElements } from '../BasicSEO';
import { useBabelSeo } from '../useBabelSeo';

export const HomePageSEO: FunctionComponent = () => {
  const resolveBabelSeo = useBabelSeo();
  const title = resolveBabelSeo('seo.homepage.title');
  const description = resolveBabelSeo('seo.homepage.description');
  const robots = {
    noArchive: false,
    noFollow: false,
    noIndex: false,
  };

  return (
    <>
      <BasicSeoElements
        title={title}
        description={description}
        imageUrl={SEO.SOCIAL_IMAGE_URL}
        robots={robots}
      />
      <Head>
        {Object.values(LOCALES).map((locale) => (
          <link
            rel="alternate"
            hrefLang={locale}
            href={`https://${PRODUCTION_DOMAIN}/${locale}/`}
            key={locale}
          />
        ))}
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://${PRODUCTION_DOMAIN}/${LOCALES.EN}/`}
        />
      </Head>
    </>
  );
};
